var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      staticClass: "noborder",
      attrs: {
        title: _vm.title,
        width: 820,
        visible: _vm.visible,
        isLoading: _vm.isLoading,
        maskClosable: false,
        destroyOnClose: true,
      },
      on: { ok: _vm.handleSubmit, cancel: _vm.handleCancel },
    },
    [
      _c(
        "div",
        { staticClass: "links-body" },
        [
          _c(
            "a-collapse",
            {
              attrs: {
                defaultActiveKey: _vm.keys,
                bordered: false,
                expandIconPosition: "left",
              },
            },
            _vm._l(_vm.linkList, function (group) {
              return _c(
                "a-collapse-panel",
                { key: group.key, attrs: { header: group.title } },
                [
                  _c(
                    "div",
                    { staticClass: "link-list" },
                    _vm._l(group.data, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "link-item",
                          class: { active: _vm.activeKey == item.id },
                          on: {
                            click: function ($event) {
                              return _vm.handleClickItem(item)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "link-title" }, [
                            _vm._v(_vm._s(item.title)),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "a-drawer",
            {
              attrs: {
                title: _vm.drawer.title,
                placement: "right",
                width: 350,
                closable: false,
                visible: _vm.drawer.visible,
                getContainer: false,
                wrapStyle: { position: "absolute" },
              },
              on: { close: _vm.onCloseDrawer },
            },
            [
              _vm.drawer.visible
                ? _c(
                    "a-form",
                    { attrs: { form: _vm.form } },
                    _vm._l(_vm.curItem.form, function (item, index) {
                      return _c(
                        "a-form-item",
                        {
                          key: index,
                          attrs: {
                            label: item.lable,
                            labelCol: { span: 6 },
                            wrapperCol: { span: 16 },
                          },
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "values." + index,
                                  {
                                    initialValue: item.value,
                                    rules: [
                                      {
                                        required: item.required,
                                        message: item.lable + "必须填写",
                                      },
                                    ],
                                  },
                                ],
                                expression:
                                  "[`values.${index}`, {\n              initialValue: item.value,\n              rules: [{ required: item.required, message: `${item.lable}必须填写` }]\n            }]",
                              },
                            ],
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-item-help" }, [
                            _c("small", {
                              domProps: { innerHTML: _vm._s(item.tips) },
                            }),
                          ]),
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }